const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class MultiColumnGridCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.updateCarousel()

    window.addEventListener('resize', () => {
      this.updateCarousel()
    })
  }

  updateCarousel () {
    const isDesktop = window.innerWidth >= 1024

    if (isDesktop) {
      if (this.carousel) {
        this.carousel.destroy()
        this.carousel = null
        this.els?.wrapper?.element.removeAttribute('data-initialised')
      }
    } else {
      if (!this.carousel) {
        this.carousel = this.setupCarousel()
      }
    }
  }

  setupCarousel () {
    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        rubberband: false,
        dragStartThreshold: 10,
        drag: true,
        slides: {
          perView: 2.5,
          spacing: 30,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.5,
              spacing: 30,
              origin: 'center',
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 4.5,
              spacing: 30,
              origin: 'center',
            },
          },
        },
      },
      [setInitialised()],
    )

    this.els?.wrapper?.element.setAttribute('data-initialised', 'true')

    return slider
  }
}

if (!customElements.get('multi-column-grid-carousel')) {
  customElements.define('multi-column-grid-carousel', MultiColumnGridCarousel)
}
